import React, { useState } from 'react';
import { Star } from 'lucide-react';

export function StarRating({ value = 0, size = 16, className = '' }) {
  return (
    <div
      className={`flex items-center gap-0.5 ${className}`}
      aria-label={`${value} out of 5 stars`}
    >
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={size}
          className={n <= value ? 'fill-[#2C3A28] text-[#2C3A28]' : 'fill-white text-white'}
        />
      ))}
    </div>
  );
}

export function StarInput({ value, onChange, size = 30 }) {
  const [hover, setHover] = useState(0);
  return (
    <div className="flex items-center gap-1.5" role="radiogroup" aria-label="Your rating">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          data-testid={`star-${n}`}
          onClick={() => onChange(n)}
          onMouseEnter={() => setHover(n)}
          onMouseLeave={() => setHover(0)}
          className="transition-transform hover:scale-110"
          aria-label={`${n} star${n > 1 ? 's' : ''}`}
        >
          <Star
            size={size}
            className={
              n <= (hover || value)
                ? 'fill-[#2C3A28] text-[#2C3A28]'
                : 'fill-white text-white'
            }
          />
        </button>
      ))}
    </div>
  );
}
